import React from 'react'
import ReactDOM from 'react-dom'

import Spinner from 'react-spinner'

import rightArrow from '../../../../static_src/images/arrow-right-white.svg'

class SweepstakesSignup extends React.Component {
  state = {
    email: '',
    success: false,
    loading: false,
  }
  submit = e => {
    e.preventDefault()

    this.setState({ loading: true })
    let form = new FormData()
    form.append('email', this.state.email)
    form.append('identifier', this.props.sweepstakesId)

    Promise.all([
      fetch('/api/mailing-list/', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.state.email,
        }),
      }),
      fetch('/blog/sweepstakes-entry/', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-CSRFToken': this.props.csrfToken,
        },
        body: form,
      })
        .then(r => r.json())
        .then(r => {
          this.setState({
            success: true,
            email: '',
            loading: false,
          })
        }),
    ]).catch(e => {
      this.setState({
        email: '',
        loading: false,
      })
    })
  }
  change = e => {
    this.setState({
      email: e.target.value,
    })
  }
  render() {
    if (this.state.loading) {
      return (
        <div>
          <Spinner />
        </div>
      )
    } else if (this.state.success) {
      return <div>Subscribed!</div>
    }
    return (
      <div className="sweepstakes-form-group">
        <form onSubmit={this.submit}>
          <input
            type="email"
            onChange={this.change}
            value={this.state.email}
            placeholder="Your Email"
          />
          <button className="btn btn-red-orange btn-sharp" type="submit">
            <img alt="Subscribe button" src={rightArrow} />
          </button>
        </form>
      </div>
    )
  }
}

export default $(document).ready(e => {
  const inputs = document.querySelectorAll('.mailing-and-sweepstakes-signup')
  if (inputs.length) {
    inputs.forEach(i => {
      ReactDOM.render(
        <SweepstakesSignup
          csrfToken={i.dataset.csrfToken}
          sweepstakesId={i.dataset.sweepstakesId}
        />,
        i
      )
    })
  }
})
